import { createUserDetailsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserDetailsQuery = createUserDetailsQuery(HTTP_CONFIG.API.Consumer.url)
